var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow" }, [
    _c(
      "div",
      { staticClass: "table-responsive" },
      [
        _c(
          "base-table",
          {
            staticClass: "table align-items-center table-flush",
            attrs: { "tbody-classes": "list", data: _vm.users },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "th",
                      { attrs: { scope: "row" } },
                      [
                        _c("base-checkbox", {
                          on: {
                            input: function($event) {
                              return _vm.clientSelect(row, $event)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("td", [
                      _c("div", { staticClass: "media align-items-center" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(row.nbNombre) +
                            " " +
                            _vm._s(row.apPaterno) +
                            " " +
                            _vm._s(row.apMaterno) +
                            "\n              "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(row.txEmail) +
                            "\n              \n          "
                        )
                      ]),
                      _c("div", [
                        _c("label", [_vm._v("Vend: ")]),
                        _vm._v("  "),
                        _c("strong", [
                          _vm._v(_vm._s(row.saler || "No asignado"))
                        ])
                      ])
                    ])
                  ]
                }
              }
            ])
          },
          [
            _c("template", { slot: "columns" }, [
              _c("th", [_vm._v("Seleccionar")]),
              _c("th", [_vm._v("Usuario")])
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }